<template>
  <v-list dense>
    <app-menu-item v-for="item in menu" :key="item.name" :item="item">
    </app-menu-item>
    <v-list-group prepend-icon="description">
      <v-list-item ripple slot="activator">
        <v-list-item-content>
          <v-list-item-title class="subheading">{{
            resx.labels.documentation.toUpperCase()
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        ripple
        @click="
          openExternalLink(
            'https://drive.google.com/file/d/1Tv6EP4yxr-eHV2CgvrG0bQdOmxWk6FTs/view'
          )
        "
        v-if="
          [
            $store.state.constants.roles.SYS_ADMIN,
            $store.state.constants.roles.SYS_BO,
            $store.state.constants.roles.SYS_SUPERVISOR
          ].indexOf($store.state.auth.user.roles[0]) != -1
        "
      >
        <v-list-item-action>
          <v-icon>business</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{
            resx.labels.businessUserManual
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        ripple
        @click="
          openExternalLink(
            'https://drive.google.com/file/d/1VFshPDhfdgMjLmuCsssAz6lgi-cvsH6c/view'
          )
        "
      >
        <v-list-item-action>
          <v-icon>people</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ resx.labels.userManual }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list-group>
  </v-list>
</template>

<script>
"use strict";

import appMenuItem from "@/components/app-menu-item.vue";

export default {
  name: "app-menu",
  components: {
    appMenuItem
  },
  data() {
    return {
      menu: [
        {
          name: "search".toUpperCase(),
          icon: "search",
          menu: [
            {
              name: "contractor",
              icon: "perm_contact_calendar",
              route: { name: "search-contractor" }
            }
          ]
        },

        {
          name: "contractors".toUpperCase(),
          icon: "perm_contact_calendar",
          menu: [
            {
              name: "list",
              icon: "view_list",
              route: { name: "contractorsCompany" }
            },
            {
              name: "suitable",
              icon: "check",
              route: { name: "suitableContractorCompany" }
            },
            {
              name: "notSuitable",
              icon: "error",
              route: { name: "noSuitableContractorCompany" }
            }
          ]
        },

        {
          name: "visits".toUpperCase(),
          icon: "history",
          menu: [
            {
              name: "visitInProgress",
              icon: "playlist_play",
              route: { name: "activeHistory" }
            },
            { name: "visitAll", icon: "view_list", route: { name: "history" } }
          ]
        },

        {
          name: "administration".toUpperCase(),
          icon: "settings",
          menu: [
            { name: "users",
              icon: "people",
              route: { name: "users" }
            },
            {
              name: "companies",
              icon: "business",
              route: { name: "companies" }
            },
            {
              name: "availableContractors",
              icon: "perm_contact_calendar",
              route: { name: "contractors" }
            },
            {
              name: "obligations",
              icon: "description",
              route: { name: "obligations" }
            },
            {
              name: "contractorType",
              icon: "person_add",
              route: { name: "contractorType" }
            },
            {
              name: "employeesType",
              icon: "group",
              route: { name: "employee-type" }
            },
            {
              name: "vehiclesType",
              icon: "directions_bus",
              route: { name: "vehicle-type" }
            },
            {
              name: "holidays",
              icon: "event_busy",
              route: { name: "holidays" }
            },
            {
              name: "swo",
              icon: "grading",
              route: { name: "swo" }
            },
            {
              name: "calendar",
              icon: "event",
              route: { name: "calendar" }
            },
            // Va ultimo a proposito: es la opcion que menos se usa del bloque.
            {
              name: "tags",
              icon: "label",
              route: { name: "tags" }
            },
          ]
        },

        {
          name: "emails".toUpperCase(),
          icon: "mail",
          menu: [
            {
              name: "emailDeliveries",
              icon: "send",
              route: { name: "emailDeliveries" }
            },
            {
              name: "emailTemplates",
              icon: "description",
              route: { name: "emailTemplates" }
            },
            {
              name: "sentEmails",
              icon: "mail",
              route: { name: "sentEmails" }
            },
            {
              name: "emailSignatures",
              icon: "gesture",
              route: { name: "emailSignatures" }
            },
            {
              name: "emailAccounts",
              icon: "alternate_email",
              route: { name: "emailAccounts" }
            }
          ]
        },

        {
          name: "contact".toUpperCase(),
          icon: "textsms",
          menu: [],
          route: { name: "sendContact" }
        }
      ]
    };
  },
  methods: {
    openExternalLink(link) {
      window.open(link, "_blank");
    }
  }
};
</script>

<style lang="scss">
.v-list--dense .v-list__tile {
  font-size: 15px !important;
  font-weight: normal !important;
}
</style>
